import React, { useEffect } from 'react';
import { Description } from '../types';

interface PersonalitySelectionProps {
  descriptions: Description[];
  selected: string;
  onSelect: (id: string) => void;
  onNext: () => void;
}

const PersonalitySelection: React.FC<PersonalitySelectionProps> = ({
  descriptions,
  selected,
  onSelect,
  onNext
}) => {
  // Add scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="section">
      <h2>Choose the personality description that best fits you:</h2>
      <div className="description-grid">
        {descriptions.map((desc) => (
          <div
            key={desc.id}
            className={`description-card ${selected === desc.id ? 'selected' : ''}`}
            onClick={() => onSelect(desc.id)}
          >
            <p className="description-text">{desc.text}</p>
          </div>
        ))}
      </div>
      <button
        onClick={onNext}
        disabled={!selected}
        className="btn-primary"
      >
        Next
      </button>
    </div>
  );
};

export default PersonalitySelection;